import { Path } from '@/main/router/routerPath';

import { NAME } from './constants';
import Edit from './Edit.vue';

export const router = new Path(NAME, { Edit });
